// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primaryLight":"#ABEAFF","textDefault":"#808080","select":"_3TLsM4iYtZlEB2JlPsywy_","clearIcon":"_31IGpQx3Pq_CUYPhoUbD20","arrowIcon":"_2uOK7A2GCGuCsMVFg51nfb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/Select.mod.css
// module id = 1092
// module chunks = 0